// extracted by mini-css-extract-plugin
export default {"fullpageLoading":"w","logo":"x"};